import { render } from "./Multicare.vue?vue&type=template&id=c66c94f4&scoped=true"
import script from "./Multicare.vue?vue&type=script&lang=js"
export * from "./Multicare.vue?vue&type=script&lang=js"

import "./Multicare.vue?vue&type=style&index=0&id=c66c94f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c66c94f4"

export default script